import { render, staticRenderFns } from "./finalEditPushStep.vue?vue&type=template&id=36eb846a&scoped=true"
import script from "./finalEditPushStep.vue?vue&type=script&lang=js"
export * from "./finalEditPushStep.vue?vue&type=script&lang=js"
import style0 from "./finalEditPushStep.vue?vue&type=style&index=0&id=36eb846a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb846a",
  null
  
)

export default component.exports